import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { RatioArrow } from './shared';

import type { IPieChartTooltipProps } from '../types';

/**
 * 饼状图 Tooltip 组件
 */
const PieChartTooltip: React.FC<IPieChartTooltipProps> = (props) => {
  const { metricName, timeRange, dataItem, showDataSourceIcon = false, dataSourceIcon } = props;

  return (
    <div className="v3-chart-tooltip v3-pie-tooltip">
      <div className="v3-tooltip-table">
        {(timeRange || metricName || (showDataSourceIcon && dataSourceIcon)) && (
          <>
            <div className="v3-tooltip-cell v3-tooltip-cell--left">
              {timeRange && <div className="v3-tooltip-header-text">{timeRange}</div>}
            </div>
            <div className="v3-tooltip-cell v3-tooltip-cell--right">
              <div className="v3-tooltip-title-right">
                {showDataSourceIcon && dataSourceIcon && (
                  <img
                    className="v3-tooltip-datasource-icon"
                    width={14}
                    height={14}
                    src={dataSourceIcon}
                    alt="dataSource"
                  />
                )}
                {metricName && <div className="v3-tooltip-title-text">{metricName}</div>}
              </div>
            </div>
          </>
        )}
        <div className="v3-tooltip-cell v3-tooltip-cell--left">
          <div className="v3-tooltip-list-item-left">
            <span className="v3-tooltip-list-item-dot" style={{ backgroundColor: dataItem.color }} />
            {dataItem.iconUrl && (
              <img
                className="v3-tooltip-list-item-icon"
                src={dataItem.iconUrl}
                alt={dataItem.iconAlt || dataItem.name}
              />
            )}
            <span className="v3-tooltip-list-item-name">{dataItem.name}</span>
          </div>
        </div>
        <div className="v3-tooltip-cell v3-tooltip-cell--right">
          <div className="v3-tooltip-list-item-right">
            <span className="v3-tooltip-list-item-value">{dataItem.value}</span>
            <span className="v3-tooltip-list-item-percent">({dataItem.percent})</span>
            {dataItem.ratio && <RatioArrow type={dataItem.ratio.type} value={dataItem.ratio.value} />}
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * 渲染饼状图 Tooltip 为 HTML 字符串
 */
export const renderPieChartTooltip = (props: IPieChartTooltipProps): string => {
  return renderToStaticMarkup(<PieChartTooltip {...props} />);
};

export default PieChartTooltip;
